import React from 'react';
import { deckPages } from '../../data/deck';
interface SlideProps {
  id: string;
  children: React.ReactNode;
}

/** One full-height presentation page with a quiet running header. */
export function Slide({
  id,
  children
}: SlideProps) {
  const index = deckPages.findIndex(page => page.id === id);
  const page = deckPages[index];
  return <section id={id} aria-label={page?.label} className="relative flex min-h-screen w-full snap-start flex-col border-t border-[rgba(1,51,43,0.08)] bg-[#F7F5F0] px-8 py-6 font-body antialiased lg:px-14" data-id="element-126" data-mp="1lnmzll43y7k6">
      <header className="flex items-center justify-between gap-4" data-id="element-127" data-mp="xzvnoimhbwjf">
        <span className="font-body text-[10px] uppercase tracking-[0.24em] text-[rgba(1,51,43,0.35)]" data-id="element-128" data-mp="y1q9s09hlup3">
          {String(index + 1).padStart(2, '0')} · {page?.label}
        </span>
        <span className="hidden font-body text-[10px] uppercase tracking-[0.24em] text-[rgba(1,51,43,0.25)] sm:inline" data-id="element-129" data-mp="o30qq45uu479">
          Meet the Filteks · From creative idea to commercial impact
        </span>
      </header>
      <div className="flex flex-1 items-center py-12 lg:py-10" data-id="element-130" data-mp="2kv71eui5ri8j">
        <div className="mx-auto w-full max-w-[1360px]" data-id="element-131" data-mp="2fyqchy34wzue">{children}</div>
      </div>
    </section>;
}